// extracted by mini-css-extract-plugin
module.exports = {"discount-card":"DiscountInfo_discount-card__zqulv","discount-card--image":"DiscountInfo_discount-card--image__vouxF"};